import { forwardRef } from 'react';
import {
  GridFilterModel,
  GridOverlay,
  GridSortModel,
  DataGridPro,
  DataGridProProps,
} from '@mui/x-data-grid-pro';
import { useIsScrolledToBottom } from '@bymason/util-hooks';
import { LinearProgress } from '../../mui/LinearProgress';
import { RiFilterFill } from '../Icons';
import { DataGridNoResultsOverlay } from '../DataGridNoResultsOverlay';
import { ControllerGridColumnsPanel } from '../ControllerGridColumnsPanel';
import { ControllerGridFilterPanel } from '../ControllerGridFilterPanel';

export * from '../ControllerGridFilterPanel';
export * from '../ControllerGridFilterInputs';
export * from '../ControllerGridColumnsPanel';
export * from '../ControllerGridToolbar';
export * from '../GridCombinedToolbarMenu';
export * from '../DataGridNoResultsOverlay';

export type OnFilterModelChange = (model: GridFilterModel, details?: unknown) => void;
export type OnSortModelChange = (model: GridSortModel, details?: unknown) => void;

export type ControllerDataGridProps = Omit<
  DataGridProProps,
  | 'autoPageSize'
  | 'disableColumnMenu'
  | 'hideFooter'
  | 'onPageChange'
  | 'onPageSizeChange'
  | 'page'
  | 'pageSize'
  | 'pagination'
  | 'paginationMode'
  | 'rowsPerPageOptions'
>;

const LoadingOverlay = () => {
  return (
    <GridOverlay>
      <LinearProgress style={{ left: 0, position: 'absolute', top: 0, width: '100%' }} />
    </GridOverlay>
  );
};

const LoadingOverlayWithBottom = () => {
  return (
    <GridOverlay>
      <LinearProgress style={{ left: 0, position: 'absolute', top: 0, width: '100%' }} />
      <LinearProgress style={{ left: 0, position: 'absolute', bottom: 0, width: '100%' }} />
    </GridOverlay>
  );
};

export default forwardRef<HTMLDivElement, ControllerDataGridProps>(function ControllerDataGrid(
  props: ControllerDataGridProps,
  ref
) {
  const isScrolledToBottom = useIsScrolledToBottom(80);

  return (
    <DataGridPro
      disableColumnReorder
      disableColumnResize
      disableColumnSelector
      disableDensitySelector
      autoHeight
      ref={ref}
      {...props}
      components={{
        LoadingOverlay: isScrolledToBottom ? LoadingOverlayWithBottom : LoadingOverlay,
        NoResultsOverlay: DataGridNoResultsOverlay,
        OpenFilterButtonIcon: RiFilterFill,
        ColumnsPanel: ControllerGridColumnsPanel,
        FilterPanel: ControllerGridFilterPanel,
        ...props.components,
      }}
      hideFooter
      disableColumnMenu
    />
  );
});
